module.exports = __webpack_public_path__ + "img/process-2.0c2f1adf.png";